require('intersection-observer'); // polyfill

import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

// https://vuejs.org/v2/guide/custom-directive.html
// https://medium.com/js-dojo/creating-custom-directives-in-vue-js-286142392fd8